<template>
  <PopularDecks />
</template>
<script>
import PopularDecks from '~/components/PopularDecks'

export default {
  components: {
    PopularDecks
  }
}
</script>
